export default __webpack_public_path__ + "static/media/alert.f185f3d7.svg";